"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

var styled_1 = require("../../ButtonRadio/styled");

exports.SelectWrapper = styled_components_1.default.div(function (_a) {
  var theme = _a.theme;
  return {
    cursor: 'cursor',
    position: 'relative'
  };
});
exports.SelectText = styled_components_1.default.input(function (_a) {
  var theme = _a.theme;
  var selectTheme = theme.components.select;
  return {
    backgroundColor: selectTheme.default.backgroundColor,
    border: 0,
    boxSizing: 'border-box',
    color: selectTheme.selected.color,
    fontFamily: theme.fontText,
    fontSize: selectTheme.default.fontSize,
    padding: "0px " + selectTheme.default.padding,
    height: '100%',
    outline: 'none',
    width: '100%'
  };
});
exports.SelectIcon = styled_components_1.default.div(function (_a) {
  var theme = _a.theme;
  var selectTheme = theme.components.select;
  return {
    padding: "0px " + selectTheme.default.padding,
    height: '100%',
    display: 'flex',
    alignItems: 'center'
  };
});
exports.DropdownMenu = styled_components_1.default.div(function (_a) {
  var _b;

  var theme = _a.theme,
      isOpen = _a.isOpen,
      value = _a.value;
  var hasValue = value !== undefined && value.length;
  var selectTheme = theme.components.select;
  return _b = {
    position: 'absolute',
    visibility: isOpen ? 'visible' : 'hidden',
    width: '100%',
    zIndex: 999,
    maxHeight: '300px',
    overflow: 'auto',
    borderColor: hasValue ? selectTheme.selected.borderColor : selectTheme.default.borderColor,
    borderWidth: selectTheme.default.borderWidth,
    borderTopWidth: 0,
    borderStyle: 'solid'
  }, _b[styled_1.BaseButtonRadioOption] = {
    borderWidth: 0
  }, _b;
});
exports.SelectBox = styled_components_1.default.div(function (_a) {
  var _b;

  var theme = _a.theme,
      value = _a.value;
  var hasValue = value !== undefined && value.length;
  var selectTheme = theme.components.select;
  return _b = {
    borderColor: hasValue ? selectTheme.selected.borderColor : selectTheme.default.borderColor,
    borderWidth: selectTheme.default.borderWidth,
    borderStyle: 'solid',
    height: selectTheme.default.height,
    alignItems: 'center',
    display: 'flex'
  }, _b[exports.SelectIcon] = {
    backgroundColor: hasValue ? selectTheme.selected.backgroundColor : selectTheme.default.backgroundColor,
    borderLeftColor: hasValue ? selectTheme.selected.borderColor : selectTheme.default.borderColor,
    borderLeftWidth: selectTheme.default.borderWidth,
    borderLeftStyle: 'solid'
  }, _b[exports.SelectText] = {
    backgroundColor: hasValue ? selectTheme.selected.backgroundColor : selectTheme.default.backgroundColor
  }, _b;
});